module.exports = __webpack_public_path__ + "img/room_5.9cb4a924.jpg";